import * as React from 'react';
import { useEffect, useState } from 'react';
import View from './View';

interface DetermineViewProps {
    view: string;
}

const DetermineView = (
    {
        children,
        view
    }: React.PropsWithChildren<DetermineViewProps>
): React.ReactElement => {
    const [currentView, setCurrentView] = useState<React.ReactElement | null>(null);

    useEffect(() => {
        React.Children.forEach<React.ReactNode>(children, (child: React.ReactNode): void => {
            if (React.isValidElement(child)) {
                if (child.type === View && child.props.name === view) {
                    setCurrentView(child);
                }
            }
        })
    });

    if (currentView) {
        return React.cloneElement(currentView, currentView.props);
    }

    return <div />;
};

DetermineView.displayName = 'DetermineView';

export default DetermineView;
